import { getDebugRing } from '../lib/devUtils';
import { clx } from '../lib/utils';

/**
 * FlexColPageContainer is a component that wraps a page container in a flex column.
 * Providing a padding of 24px on all sides.
 */
export const FlexColPageContainer = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={clx(
        'flex grow flex-col items-center justify-center overflow-y-auto px-6',
        className,
        getDebugRing('green')
      )}
    >
      {children}
    </div>
  );
};
